/**
 * @param {{
 *   AiUsagesService: ReturnType<import('../../services/AiUsagesService').default>,
 * }} param0
 */
export default function aiUsagesUseCase({ AiUsagesService }) {
  const getAiUsages = () => {
    return AiUsagesService.getAiUsages();
  };

  return {
    getAiUsages: getAiUsages,
  };
}
